import Page from "@jumbo/shared/Page";
import AuthenticateAndRolesMiddleware from "../Middleware";
import ListPurchaseOrders from "app/pages/PurchaseOrder/ListPurchaseOrder";
import AddEditPurchaseOrder from "app/pages/PurchaseOrder/AddEditPurchaseOrder";


const routesName = "/dashboards/purchaseOrder";

export const purchaseOrderRoute = [
  {
    middleware: [
      {
        element: AuthenticateAndRolesMiddleware,
        fallbackPath: "/login"
      },
    ],
    routes: [
      {
        path: `${routesName}`,
        element: <Page component={ListPurchaseOrders} />
      },
      {
        path: `${routesName}/add`,
        element: <Page component={AddEditPurchaseOrder} />,
      },
    
    ],
  },]
